import React, { Component } from 'react';
import axios from 'axios';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import classes from '../GroupManagement/GroupManagement.module.css';
import Star from '@material-ui/icons/Star';
import StarBorder from '@material-ui/icons/StarBorder';
import apiUrl from "../../../shared/config";


export default class UserManagement extends Component {
    _isMounted = false;

    state = {
        permission_types: [],
        user_permission_types: []
    };

    componentDidMount() {
        this._isMounted = true;
        this.getPermissionTypes()
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getPermissionTypes() {
        axios.get(apiUrl +'PermissionTypes/getPermissionTypes')
            .then(response => {
                if (this._isMounted) {
                    this.setState({permission_types: response.data, user_permission_types: this.props.user.userPermissions});
                }
            });
    }

    togglePermissionHandler = (value, permission_type) => {
        axios.post(apiUrl + 'Users/setUserPermissions?user_id=' + this.props.user.userId + '&value=' + value+ '&permission_type=' + permission_type + '&token=' + this.props.token)
            .then(response => {
                this.setState({user_permission_types: response.data});
            })

    };

    userHasPermissions = (permission) => {
        return this.state.user_permission_types.filter(
            (val) => {
                return val.permission_id === permission.permission_type_id
            }).length > 0
    }

    render() {
        const permissions_jsx = [];
            this.state.permission_types.forEach((permission) => {
                const permission_jsx =
                    (this.props.givePermissions || this.userHasPermissions(permission))
                        ? (<div key={this.props.user.userId + '-permission-' + permission.permission_type_id}>
                            <span style={{display: "inline-flex"}}>
                                {this.props.givePermissions
                                    ? <OverlayTrigger
                                        trigger={['hover', 'focus']}
                                        rootClose
                                        rootCloseEvent="click"
                                        key={'permission-toggle-' + permission.permission_type_name + '-' + this.props.user.userId}
                                        placement='top'
                                        overlay={
                                            <Popover id='manager_status'>
                                                <Popover.Title as="h3">{'Toggle ' + permission.permission_type_name}</Popover.Title>
                                                <Popover.Content className="pattern-exercise-description" style={{whiteSpace: "break-spaces"}}>
                                                    {permission.permission_type_description}
                                                    {"\n\nClick here to toggle the '" + permission.permission_type_name + "' permission for this user."}
                                                </Popover.Content>
                                            </Popover>
                                        }
                                    >
                                        <span onClick={() => {this.togglePermissionHandler(!this.userHasPermissions(permission), permission.permission_type_id)}}>
                                            {this.userHasPermissions(permission) ? (<Star/>) : (<StarBorder/>)}
                                            {permission.permission_type_name}
                                        </span>
                                    </OverlayTrigger>
                                    : <OverlayTrigger
                                        trigger={['hover', 'focus']}
                                        rootClose
                                        rootCloseEvent="click"
                                        key={'permission-' + permission.permission_type_name + '-' + this.props.user.userId}
                                        placement='top'
                                        overlay={
                                            <Popover id='manager_status'>
                                                <Popover.Title as="h3">{permission.permission_type_name}</Popover.Title>
                                                <Popover.Content className="pattern-exercise-description">
                                                    {permission.permission_type_description}
                                                </Popover.Content>
                                            </Popover>
                                        }
                                    >
                                        <span>{permission.permission_type_name}</span>
                                    </OverlayTrigger>
                                }
                            </span>
                        </div>)
                        : '';

                permissions_jsx.push(permission_jsx);
            });

        return (
            <div className={classes.GroupMembers}>
                {permissions_jsx}
            </div>
        );
    }
}